import React from 'react';
import PropTypes from 'prop-types';
import { Heading } from 'Components/molecules/Heading';
import { Icon } from 'Components/atoms/Icon';
import { Link } from 'Components/molecules/Link';
import { Tooltip } from 'Components/molecules/Tooltip';
import { Accordion } from 'Components/organisms/Accordion';
import { withPolaris } from 'Components/protons/Polaris';
import './_style.scss';

const AtAGlanceCard = ({
  context: {
    cssPrefix,
  },
  atAGlanceData,
  reviewLink,
  iconOpen,
  iconClose,
  tooltipIcon,
  tooltipCloseIcon,
}) => {
  const formatContentData = (dataArr) => (
    <ul className={`${cssPrefix}__ataglance-card--list`}>
      {dataArr.map(({ title, value, info }, index) => (
        <li
          key={index}
          className={`${cssPrefix}__ataglance-card--list-item`}
        >
          <p className={`${cssPrefix}__ataglance-card--list-item--title`}>{title}</p>
          <Tooltip
            icon={tooltipIcon}
            content={info}
            closeLabel={<Icon icon={tooltipCloseIcon} />}
          />
          <p className={`${cssPrefix}__ataglance-card--list-item--value`}>{value}</p>
        </li>
      ))}
    </ul>
  );

  const formattedData = [
    {
      title: 'Key specifications',
      content: formatContentData(atAGlanceData.keySpecs),
    },
    {
      title: 'Dimensions & weight',
      content: formatContentData(atAGlanceData.dimensions),
    },
  ];

  return (
    <div className={`${cssPrefix}__ataglance-card`}>
      <Heading
        size={3}
        extraClassNames={{
          [`${cssPrefix}__ataglance-card--title`]: true,
        }}
      >
        At a glance
      </Heading>
      {formattedData && (
        <Accordion
          title="Dimensions & weight"
          items={formattedData}
          iconOpen={iconOpen}
          iconClose={iconClose}
          extraClassNames={{
            [`${cssPrefix}__ataglance-card--accordion`]: true,
          }}
        />
      )}
      <Link
        href={reviewLink?.url}
        extraClassNames={{
          [`${cssPrefix}__ataglance-card--review-link`]: true,
        }}
      >
        {reviewLink?.title}
      </Link>
    </div>
  );
};

AtAGlanceCard.propTypes = {
  context: PropTypes.shape({
    cssPrefix: PropTypes.string,
  }),
  atAGlanceData: PropTypes.shape({
    dimensions: PropTypes.arrayOf(PropTypes.shape({
      info: PropTypes.string,
      value: PropTypes.string,
      title: PropTypes.string,
    })),
    keySpecs: PropTypes.arrayOf(PropTypes.shape({
      info: PropTypes.string,
      value: PropTypes.string,
      title: PropTypes.string,
    })),
  }),
  reviewLink: PropTypes.shape({
    title: PropTypes.string,
    url: PropTypes.string,
  }),
  iconOpen: PropTypes.string,
  iconClose: PropTypes.string,
  tooltipIcon: PropTypes.string,
  tooltipCloseIcon: PropTypes.string,
};

AtAGlanceCard.defaultProps = {
  context: {
    cssPrefix: 'polaris',
  },
  atAGlanceData: {},
  reviewLink: {},
  iconOpen: 'polaris__ico-arrow_down',
  iconClose: 'polaris__ico-arrow_up',
  tooltipIcon: 'polaris__ico-info',
  tooltipCloseIcon: 'polaris__ico-close',
};

export default withPolaris(AtAGlanceCard);
